var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkActionDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.394 5.189L4.25 8.333 2.855 6.937 1.459 5.542l-.708.708-.708.708L2.147 9.06l2.103 2.104L8.105 7.31l3.854-3.854-.705-.706a74.178 74.178 0 00-.71-.705c-.003 0-1.42 1.415-3.15 3.144z",
    fill: "currentColor"
  })));
}
export default SvgCheckmarkActionDone;